import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DefaultPhotoDirective} from "./default-photo.directive";



@NgModule({
  declarations: [DefaultPhotoDirective],
  exports: [DefaultPhotoDirective],
  imports: [
    CommonModule
  ]
})
export class DefaultPhotoModule { }
